const TOKEN_STORAGE_KEY = "miyogurAuthToken";

const safeStorage = () => {
  try {
    return window.localStorage;
  } catch (_) {
    return null;
  }
};

export const getAuthToken = () => {
  const storage = safeStorage();
  if (!storage) {
    return null;
  }
  return storage.getItem(TOKEN_STORAGE_KEY);
};

export const setAuthToken = (token) => {
  const storage = safeStorage();
  if (!storage) {
    return;
  }

  if (typeof token !== "string" || token.length === 0) {
    storage.removeItem(TOKEN_STORAGE_KEY);
    return;
  }

  storage.setItem(TOKEN_STORAGE_KEY, token);
};

export const clearAuthToken = () => {
  const storage = safeStorage();
  if (!storage) {
    return;
  }
  storage.removeItem(TOKEN_STORAGE_KEY);
};

export const syncTokenFromUrl = () => {
  if (typeof window === "undefined" || typeof window.location === "undefined") {
    return null;
  }

  const url = new URL(window.location.href);
  const token = url.searchParams.get("token");

  if (!token) {
    return null;
  }

  setAuthToken(token);
  url.searchParams.delete("token");

  const remainingQuery = url.searchParams.toString();
  const nextUrl = `${url.pathname}${remainingQuery ? `?${remainingQuery}` : ""}${url.hash}`;
  window.history.replaceState({}, "", nextUrl);

  return token;
};
